import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { DBSchema, IDBPDatabase, openDB } from 'idb';

interface AvatarDB extends DBSchema {
  avatars: {
    key: string;
    value: {
      avatar: string;
      updatedAt: string | undefined;
    };
  };
}

@Injectable({
  providedIn: 'root',
})
/**
 * this Service is created to handle all indexedDB actions
 *
 */
export class IndexedDBService {
  private dbPromise!: Promise<IDBPDatabase<AvatarDB>>;
  isBrowser: boolean;

  constructor() {
    const platformId = inject(PLATFORM_ID);
    this.isBrowser = isPlatformBrowser(platformId);

    if (this.isBrowser) {
      this.dbPromise = openDB<AvatarDB>('my-database', 1, {
        upgrade(db) {
          db.createObjectStore('avatars');
        },
      });
    }
  }

  async saveAvatar(
    key: string,
    avatar: string,
    updatedAt: string | undefined,
  ): Promise<void> {
    if (this.isBrowser) {
      const db = await this.dbPromise;
      let avatarAlreadyExist = await db.get('avatars', key);
      if (avatarAlreadyExist) {
        await db.delete('avatars', key);
      }
      const avatarObject = {
        avatar: avatar,
        updatedAt: updatedAt,
      };
      await db.put('avatars', avatarObject, key);
    }
  }

  async getAvatar(
    key: string,
  ): Promise<{ avatar: string; updatedAt: string | undefined } | undefined> {
    if (this.isBrowser) {
      const db = await this.dbPromise;
      return db.get('avatars', key);
    }
    return undefined;
  }

  async deleteAvatar(key: string): Promise<void> {
    if (this.isBrowser) {
      const db = await this.dbPromise;
      await db.delete('avatars', key);
    }
  }
}
